var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-link',{class:`apex_link_${_vm.getSize()}`,attrs:{"type":_vm.type,"underline":_vm.underline,"disabled":_vm.disabled,"icon":_vm.icon,"href":_vm.href,"to":_vm.to,"params":_vm.params},on:{"click":_vm.jump}},[(_vm.value)?_c('span',[_vm._v(_vm._s(_vm.value))]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }